import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import useMakeFiltersData from "components/Filters/useMakeFiltersData";

import { INTENT_PROJECTS_SUGGESTIONS_DICTIONARY } from "./constants";
import { SEARCH_INTENT_PROJECTS_SUGGESTIONS } from "./gql";
import useIntentProjectsFiltersVariables from "./useFiltersVariables";

const useSearchIntentProjectsSuggestions = () => {
  const { fullTextSearch, predicates, filterVariablesLoaded } = useIntentProjectsFiltersVariables();

  const { data, error, loading, previousData } = useQuery(SEARCH_INTENT_PROJECTS_SUGGESTIONS, {
    variables: {
      input: {
        fullTextSearch,
        predicates,
        fields: null,
      },
    },
    skip: !filterVariablesLoaded,
  });

  const cachedSuggestions = useMemo(() => {
    return (
      data?.searchIntentProjectsSuggestions?.fields ||
      previousData?.searchIntentProjectsSuggestions?.fields ||
      []
    );
  }, [data, previousData]);

  const filteredCount = useMemo(() => {
    return (
      data?.searchIntentProjectsSuggestions?.filteredCount ||
      previousData?.searchIntentProjectsSuggestions?.filteredCount ||
      0
    );
  }, [data, previousData]);

  const { filters, filterOptionsMap } = useMakeFiltersData({
    suggestions: cachedSuggestions,
    dictionary: INTENT_PROJECTS_SUGGESTIONS_DICTIONARY,
  });

  return {
    filters,
    filterOptionsMap,
    filteredCount,
    loading: loading || !filterVariablesLoaded,
    error,
  };
};

export default useSearchIntentProjectsSuggestions;
